import React, { PureComponent } from 'react';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

interface IImageProps {
  imageName: string;
  altText: string;
  extension: string;
  className?: string[];
}

interface IImageState {
  src: string;
  imageName: string;
  sourceWeb: {
    srcWeb: string;
    sourceRefWeb: any;
  };
}

export default class Image extends PureComponent<IImageProps, IImageState> {
  private imageRef: React.MutableRefObject<HTMLImageElement>;

  constructor(props: IImageProps) {
    super(props);
    this.state = {
      src: require(`../../../assets/${this.props.imageName}.${this.props.extension}`),
      imageName: this.props.imageName,
      sourceWeb: {
        srcWeb: require(`../../../assets/${this.props.imageName}.webp`),
        sourceRefWeb: React.createRef()
      }
    };
    this.imageRef = React.createRef();
  }

  componentDidMount() {
    const src = this.imageRef.current.getAttribute('data-src');
    if (src.indexOf('$staticlink$') === -1 && src.indexOf('http') !== -1) {
      this.setState({
        ...this.state, src: src,
        sourceWeb: {
          ...this.state.sourceWeb,
          srcWeb: this.state.sourceWeb.sourceRefWeb.current.getAttribute('data-srcset')
        }
      });
    }
  }


  render() {
    const { altText, className } = this.props;
    const { sourceWeb, src } = this.state;

    return (
      <picture>
        <source data-srcset={sourceWeb.srcWeb} ref={sourceWeb.sourceRefWeb} type="image/webp"
        />
        <img
          className={className && className.join(' ')}
          ref={this.imageRef}
          data-src={src}
          alt={altText}
        />
      </picture>
    );
  }
}
